import React from 'react'
import { Button, Modal } from '@clickcease/cc-client-components-lib'
import { ImplementTag } from 'Features/OnboardingWizard/components/ImplementTag/ImplementTag'
import { TagInstallationConatiner, TagInstallationFooter } from './TagInstallation.styled'
import { useTranslation } from 'react-i18next'

type GetTagModalProps = {
  isOpen: boolean
  onOpenChange: (a: boolean) => void
  domainAddress?: string
}

export const TagInstallation = ({ domainAddress, isOpen, onOpenChange }: GetTagModalProps) => {
  const { t } = useTranslation('domainManagement')

  return (
    <Modal
      id={'tag-installation-modal'}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      style={{ width: '820px', height: '650px' }}
    >
      <TagInstallationConatiner>
        <ImplementTag
          addedDomainAddress={domainAddress || ''}
          noFooter
          smallIcons
          onFinish={() => {}}
          onBack={() => {}}
        />
        <TagInstallationFooter>
          <Button onClick={() => onOpenChange(false)}>{t('tracking_params_modal.done')}</Button>
        </TagInstallationFooter>
      </TagInstallationConatiner>
    </Modal>
  )
}
